export type MemberStatus = 'active' | 'pending';

export const ACTIVE = 'active';
export const PENDING = 'pending';
